import React from "react";

/**
 * ConsultingHero.jsx
 * Uses uploaded hero-cm-hc33 image path:
 *   /mnt/data/Screenshot 2025-11-16 153549.png
 *
 * - Two-tone heading
 * - Right-side slider dot-cm-hc33s (visual only)
 * - Read More CTA
 * - Contact info strip-cm-hc33
 * - Curved white bottom SVG
 * - Pure CSS
 */

const HERO_BG = "https://i.postimg.cc/t4YRDRbd/6390.jpg";

export default function HeroCard33() {
  return (
    <>
      <section className="consult-hero-cm-hc33" role="region" aria-label="Consulting hero-cm-hc33">
       
        {/* background */}
        <div className="hero-cm-hc33-bg" style={{ backgroundImage: `url('${HERO_BG}')` }} />

        {/* dark overlay for contrast */}
        <div className="hero-cm-hc33-overlay" />

        {/* centered container */}
        <div className="hero-cm-hc33-inner">
          <div className="hero-cm-hc33-content">
            <h1 className="hero-cm-hc33-title">
              <span className="accent-cm-hc33">WE</span> NEVER DREAMED ABOUT<br />
              SUCCESS, <span className="accent-cm-hc33">WE WORKED</span> FOR IT
            </h1>

            <p className="hero-cm-hc33-sub">WELCOME TO CONSULTING 20 YEAR EXPERIENCE</p>

            <a className="btn-cm-hc33-read" href="#read">READ MORE</a>
          </div>

          {/* right-side vertical dot-cm-hc33s */}
          <div className="hero-cm-hc33-dot-cm-hc33s" aria-hidden>
            <div className="dot-cm-hc33 square-cm-hc33" />
            <div className="dot-cm-hc33 outlined-cm-hc33" />
            <div className="dot-cm-hc33 small-cm-hc33" />
          </div>

        </div>

        {/* contact strip-cm-hc33 */}
        <div className="contact-strip-cm-hc33">
          <div className="strip-cm-hc33-inner">
            <div className="strip-cm-hc33-item">📞 +123-456-7890</div>
            <div className="strip-cm-hc33-item">✉ consulting12@demo.com</div>
            <div className="strip-cm-hc33-item">🕒 Mon To Fri 08:00 - 18:00</div>
          </div>
        </div>

        {/* curved white bottom */}
        <div className="hero-cm-hc33-curve" aria-hidden>
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0 40 C 360 120 1080 -40 1440 40 L1440 120 L0 120 Z" fill="#fff"/></svg>
        </div>
      </section>

      <style>{`
/* ---------- HERO BASE ---------- */
.consult-hero-cm-hc33 {
  position: relative;
  min-height: 84vh;overflow:hidden;
  
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial;
}

/* background image */
.hero-cm-hc33-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  z-index: 0;
  transform: scale(1.03);
}

/* overlay */
.hero-cm-hc33-overlay {
  position: absolute;margin-top:-30px;
  inset: 0;
  background: linear-gradient(180deg, rgba(9,18,35,0.56) 0%, rgba(9,18,35,0.58) 60%, rgba(9,18,35,0.66) 100%);
  z-index: 1;
}

/* inner content area */
.hero-cm-hc33-inner {
  position: relative;
  z-index: 4;
  width: min(1100px, 94%);
  margin: 0 auto;
  padding-top: 15vh;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* left content */
.hero-cm-hc33-content {
  max-width: 720px;
  color: #fff;
  padding-left: 2%;
}

/* title: two-tone */
.hero-cm-hc33-title {
  font-size: clamp(1.8rem, 4.2vw, 3.8rem);
  line-height: 1.02;
  margin: 0 0 19px;
  font-weight: 900;
  letter-spacing: -0.02em;
}
.hero-cm-hc33-title .accent-cm-hc33 {
  color: #ff6e5c;
}

/* subheading */
.hero-cm-hc33-sub {
  color: rgba(255,255,255,0.9);
  margin: 10px 0 22px;
  font-weight:700;
  letter-spacing: 0.02em;
}

/* CTA */
.btn-cm-hc33-read {
  display:inline-block;
  padding: 12px 18px;
  border: 2px solid rgba(255,255,255,0.9);
  color: white;
  text-decoration:none;
  border-radius:6px;
  font-weight:800;
  background: transparent;
}

/* right-side vertical dot-cm-hc33s */
.hero-cm-hc33-dot-cm-hc33s {
  margin-left: auto;
  margin-right: 4%;
  display:flex;
  flex-direction:column;
  gap: 14px;
  align-items:center;
}
.dot-cm-hc33 { width:12px; height:12px; border-radius:4px; background: #ff6e5c; opacity: 0.95; }
.dot-cm-hc33.outlined-cm-hc33 { width:12px; height:12px; background: transparent; border:2px solid rgba(255,255,255,0.75); border-radius:6px; }
.dot-cm-hc33.small-cm-hc33 { width:8px; height:8px; background: rgba(255,255,255,0.8); opacity:0.7; border-radius:6px; }
.dot-cm-hc33.square-cm-hc33 { border-radius:3px; }

/* contact strip-cm-hc33 */
.contact-strip-cm-hc33 {
  position: absolute;
  left: 6%;
  right: 6%;
  bottom: 25%;
  z-index: 5;
  display:flex;
  justify-content:center;
}
.strip-cm-hc33-inner {
  width: min(1100px, 94%);
  display:flex;
  gap: 24px;
  align-items:center;
  justify-content: center;
  color: rgba(255,255,255,0.95);
  border-top: 1px solid rgba(255,255,255,0.06);
  padding-top: 20px;
  font-weight:700;
}

/* curved white bottom */
.hero-cm-hc33-curve {
  position: absolute;
  left: 0;
  right: 0;
  bottom: -15px;
  z-index: 6;
  height: 120px;
  pointer-events:none;
}

/* responsive */
@media (max-width: 980px) {
  .hero-cm-hc33-inner { flex-direction: column; align-items:flex-start; padding-top: 6vh; }
  .hero-cm-hc33-dot-cm-hc33s { margin-left: 0; margin-top: 18px; order: 2; align-self:flex-start; margin-left: 6%; }
  .contact-strip-cm-hc33 { bottom: 6%; }
  .hero-cm-hc33-content { padding-left: 6%; padding-right: 6%; }
}
@media (max-width: 520px) {.hero-cm-hc33-curve {
 
  bottom: -15px;
  z-index: 6;
  height: 30px;
  pointer-events:none;
}
  .hero-cm-hc33-title { font-size: 1.6rem; }
  .strip-cm-hc33-inner { flex-direction: column; gap:12px; padding-top:12px; }
  .hero-cm-hc33-dot-cm-hc33s { display:none; }
}
      `}</style>
    </>
  );
}
